var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveListEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 75,
    viewBox: "0 0 179 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.161 75H174.839C177.542 71.9933 179 68.7916 179 65.4698C179 48.0562 138.929 33.9397 89.5 33.9397C40.0705 33.9397 0 48.0562 0 65.4698C0 68.7916 1.45805 71.9933 4.161 75Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4021 0C75.0972 0 68.9098 6.09597 68.7443 13.3452C68.5787 21.1093 68.6822 28.7705 69.9859 36.4316C70.6067 39.4796 71.393 42.4246 72.3656 45.3696C72.7795 46.5435 74.1246 47.4703 75.3041 47.4703C75.3869 47.4703 75.4283 47.4703 75.5111 47.4703C76.6906 47.4703 77.2079 46.5435 76.7527 45.3902C76.4423 44.6076 76.8355 43.9692 77.6218 43.9898C78.4082 44.0104 79.2773 44.6488 79.6084 45.4108C80.1051 46.5435 81.5329 47.4497 82.7125 47.4497C82.7952 47.4497 82.8366 47.4497 82.9194 47.4497C84.0989 47.4497 84.5542 46.5641 83.9955 45.452C83.623 44.69 83.9955 44.0722 84.7611 44.0928C85.5475 44.1134 86.458 44.7312 86.8512 45.4726C87.4306 46.5847 88.9205 47.4497 90.1208 47.4497C90.2036 47.4497 90.2449 47.4497 90.3277 47.4497C91.5073 47.4497 91.8797 46.5847 91.2589 45.5138C90.8451 44.7724 91.1555 44.1752 91.9418 44.1958C92.7282 44.2163 93.6801 44.8136 94.1146 45.555C94.7768 46.6259 96.3496 47.4703 97.5291 47.4703C97.5705 47.4703 97.5912 47.4703 97.6326 47.4703C98.8742 47.4703 99.1846 46.6053 98.4396 45.4932C96.8255 42.8159 95.6667 40.1798 94.7768 37.173C93.0386 29.3265 93.7629 21.5418 94.6527 13.6335C95.5839 6.24013 89.8932 0 82.4021 0Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4519 14.1148C91.1689 15.021 89.0582 13.4146 90.0928 9.85179C90.1342 9.66644 90.4032 9.62525 90.486 9.83119C91.4172 12.0554 93.9833 13.0439 92.4519 14.1148Z",
    fill: "#801E0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.637 9.04864C88.1683 9.68707 85.4161 18.275 81.1325 15.5771C78.5251 13.9295 80.8841 12.3026 83.5329 11.3346C85.1264 10.7374 85.7058 8.65735 86.637 9.04864Z",
    fill: "#801E0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3613 21.364C86.2413 21.364 85.3333 20.0455 85.3333 18.419C85.3333 16.7925 86.2413 15.474 87.3613 15.474C88.4813 15.474 89.3893 16.7925 89.3893 18.419C89.3893 20.0455 88.4813 21.364 87.3613 21.364Z",
    fill: "#801E0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1201 10C74.4535 10.8333 72.9735 13.7845 75.1201 14.5C76.6201 15 76.6201 11.5 75.1201 10Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1282 24.6921C92.9539 24.1081 93.6561 24.1326 94.2229 25.0004C95.5741 27.069 97.4155 30.0569 98.2871 32.6639C98.7073 33.9206 99.0364 35.4644 98.6307 36.8576C98.41 37.6154 97.9778 38.3033 97.3013 38.8098C96.6476 39.2991 95.8728 39.5399 95.0695 39.6246C94.074 39.7296 93.178 38.971 93.0683 37.9303C92.9586 36.8895 93.6767 35.9608 94.6722 35.8558C94.9823 35.8231 95.1177 35.7563 95.1575 35.7325C95.1582 35.7302 95.159 35.7277 95.1598 35.7249C95.2162 35.5313 95.226 34.9653 94.8641 33.883C94.1718 31.8122 93.7139 30.1698 92.9265 27.9422C92.2772 26.1053 91.8266 26.1529 92.1282 24.6921Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0092 9.80985C60.1143 8.71029 61.0908 7.90413 62.1904 8.00924C64.4429 8.22455 67.9981 10.2884 68.3295 15.6112C68.5384 18.9648 69.5541 20.5828 70.5001 21.0001C71.5107 21.446 73.2758 22.7969 72.8299 23.8074C72.3841 24.818 71.5107 25.446 70.5001 25.0001C68.5572 24.143 64.6618 21.0708 64.3373 15.8598C64.1354 12.6178 62.2239 12.0307 61.8098 11.9911C60.7102 11.886 59.9041 10.9094 60.0092 9.80985Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 89.5029,
    y1: 19.639,
    x2: 89.5029,
    y2: 69.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4764,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 68.4108,
    y1: 6.08447,
    x2: 96.5471,
    y2: 45.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#DD2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 94.3669,
    y1: 41.6041,
    x2: 92.1529,
    y2: 28.2615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#DD2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 59.8831,
    y1: 10.1977,
    x2: 69.4005,
    y2: 25.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#DD2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveListEmpty);
export default __webpack_public_path__ + "static/media/live-list-empty.53a07fc958af006be7402da18eca93ca.svg";
export { ForwardRef as ReactComponent };